var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showNavbar)?_c('NavBar'):_vm._e(),_c('v-main',{staticStyle:{"margin-top":"80px"}},[_c('router-view'),_c('SnackbarNotification')],1),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }